import {
  type BoxProps,
  Icon,
  ICON_SIZES,
  type IconName,
  IndicatorDotVariants,
  IndicatorDotWrapper,
  Popover,
  usePopoverState,
} from '@talos/kyoko';
import type { CSSProperties, PropsWithChildren, ReactNode } from 'react';
import { SidebarPopoverIndicator } from './SidebarPopoverIndicator';
import { SidebarItemWrapper } from './styles';

export function SidebarItem({
  showIndicator,
  children,
  menuItems,
  icon,
  menuMaxHeight,
  ...props
}: PropsWithChildren<BoxProps> & {
  showIndicator?: boolean;
  menuItems?: ReactNode;
  icon?: IconName;
  highlight?: boolean;
  menuMaxHeight?: CSSProperties['maxHeight'];
}) {
  const popover = usePopoverState({
    trigger: 'hover',
    placement: 'right-end',
    usePortal: true,
    noPaddingAndBorder: true,
    delay: 200,
    hideDelay: 300,
  });
  return (
    <Popover {...popover} maxHeight={menuMaxHeight}>
      <SidebarItemWrapper {...props}>
        {showIndicator ? (
          <IndicatorDotWrapper show={showIndicator} variant={IndicatorDotVariants.Notification}>
            {children || (icon && <Icon icon={icon} size={ICON_SIZES.MEDIUM} />)}
          </IndicatorDotWrapper>
        ) : (
          children || (icon && <Icon icon={icon} size={ICON_SIZES.MEDIUM} />)
        )}
        {menuItems && <SidebarPopoverIndicator />}
      </SidebarItemWrapper>
      {menuItems}
    </Popover>
  );
}
